import React, { useEffect, useState } from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Verified = ({ history }) => {
    const [accountType, setAccountType] = useState(null);

    useEffect(() => {
        setInterval(() => {
            let step =localStorage.getItem('navigation');
            if(step !== ""){
                history.push('/add-account');
            }
        }, 500);
        const search = history.location.search;
        if (search) {
            const params = new URLSearchParams(search);
            const type = params.get('accountType');
            if (type) {
                setAccountType(type);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        <div className="account-setup-wrapper">
            <div className="form-container">
                <div className="form-header mt-md-3 mt-0">
                    <h2>CONGRATULATIONS!</h2>
                    {accountType ?
                        <span>Your "Individual" account has been setup.<br /> What would you like to do next?</span>
                        :
                        <span>You're verified!<br /> How would you like to get started?</span>
                    }

                </div>
                <div className="mt-4">
                    <div className="d-flex mb-3 plan-types">
                        <button className="custom-btn-primary mr-2 shadow p-2" disabled={true}>
                            PLAN <FontAwesomeIcon id="plan-account-tooltip" icon={faQuestionCircle} />
                        </button>
                        <UncontrolledTooltip innerClassName="text-left fs12" placement="right" target="plan-account-tooltip">
                            Early retirement? Buying your dream home? Expecting a newborn child?
                             — life moments that provide great joy, but come with so many financial questions.
                              Don’t worry, we’re by your side to guide you through every step.
                        </UncontrolledTooltip>
                        <button className="custom-btn-primary ml-2 shadow p-2" onClick={() => history.push('/add-account')}>
                            INVEST <FontAwesomeIcon id="invest-account-tooltip" icon={faQuestionCircle} />
                        </button>
                        <UncontrolledTooltip innerClassName="text-left fs12" placement="right" target="invest-account-tooltip">
                            Want to reduce risk, reduce taxes, and reduce fees?
                            We will build a custom portfolio for you that maximizes return while reducing risk,
                            and leverages technology to lower your taxes and fees.
                        </UncontrolledTooltip>
                    </div>
                    <div className="d-flex plan-types">
                        <button className="custom-btn-primary mr-2 shadow p-2" disabled={true}>
                            PROTECT <FontAwesomeIcon id="protect-account-tooltip" icon={faQuestionCircle} />
                        </button>
                        <UncontrolledTooltip innerClassName="text-left fs12" placement="right" target="protect-account-tooltip">
                            Let's get you right amount of coverage that ensures peace of mind.
                            Be it for your home, auto or life. We will help you find the best coverage that meets your unique needs.
                        </UncontrolledTooltip>
                        <button className="custom-btn-primary ml-2 shadow p-2" disabled={true}>
                            TAX <FontAwesomeIcon id="tax-account-tooltip" icon={faQuestionCircle} />
                        </button>
                        <UncontrolledTooltip innerClassName="text-left fs12" placement="right" target="tax-account-tooltip">
                            Stressed out about taxes? We’re here to make tax preparation and filing simple.
                            Just upload some files, and we'll do the rest. We'll also optimize your taxes,
                            and ensure you get the largest eligible refund.
                        </UncontrolledTooltip>
                    </div>
                    <div className="button_wrapper">
                        <button className="custom-btn-primary">
                            ONE TIME CONSULTATION <FontAwesomeIcon id="tax-account-tooltip" icon={faQuestionCircle} />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default Verified;
